<template>
  <div :class="className">
    <label>{{ label }}</label>
    <picture-input 
      ref="pictureInput"
      width="600" 
      height="600" 
      margin="16" 
      accept="image/*" 
      size="10" 
      button-class="btn"
      :prefill="value"
      :removable="true"
      @change="onChange"
      @remove="onRemove"
      :crop="false"
    >
    </picture-input>
    <TypographyInputError v-if="hasErrors">{{ error }}</TypographyInputError>
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
    <TypographyMeta v-if="meta" v-html="meta"></TypographyMeta>
  </div>
</template>

<script>
import PictureInput from "@/packages/vue-picture-input";
import { mapActions } from 'vuex'
import { generateUuid } from '@/helpers'

export default {
  inject: ["$validator"],
  props: {
    label: String,
    value: { type: String, default: "" },
    hint: String,
    meta: String,
    fieldKey: [ String, Number ],
    scopeId: [ String, Number ],
  },
  data() {
    return {
      error: null
    };
  },
  components: {
    PictureInput
  },
  computed: {
    className() {
      return [
        "base-picture-input",
        {
          "base-picture-input--error": this.hasErrors
        }
      ];
    },
    hasErrors() {
      return this.error;
    }
  },
  methods: {
    ...mapActions('shopifyApi', ['REQUEST']),
    async onChange (image) {
        if (!image) {
            this.error = 'FileReader API not supported: use the <form>, Luke!'
            return
        }
        
        this.error = null


        try {
            const splittedName = this.$refs.pictureInput.file.name.replace(/\s/g, '-').split('.')
            const filename = splittedName.slice(0, -1).join('.')
            const extension = splittedName[splittedName.length - 1 ]

            // Don't pass this.fieldKey to finalName, if so there will be an error during image saving to Shopify CDN in situation when:
            // Picture inputs are in repeater and you create new instances of repeater. New instances fieldKey includes string `[i]`,
            // Shopify CDN doesn't accept square brackets in file names, so error occurs and images don't save.
            const finalName = filename + new Date().getTime() + generateUuid() + '.' + extension
            
            let url = await this.uploadHandler({ 
                base64: image,
                filename: finalName
            })
            this.$emit('input', url)
        } catch (error) {
            console.error('Cannot upload image', error)
            this.error = 'Cannot upload image'
        }
    },
    onRemove () {
        this.$emit('input', null)
    },

    async uploadHandler({ base64, filename }) {
        base64 = base64.substr(base64.indexOf(',') + 1);
        try {
            let { url } = await this.REQUEST({ 
                endpoint: 'image',
                method: 'POST',
                data: {
                    filename,
                    base64
                }
            })

            return url
        } catch (error) {
            throw error
        }
    }
  }
};
</script>

<style lang="scss">
  @import './base-button.scss';
  @import './src/assets/styles/breakpoints.scss';

  .base-picture-input {
    width: 100%;

    label {
      display: block;
      margin-bottom: 17px;
      font-size: 14.6px;
      line-height: 1.43;
    }

    .picture-input {
      margin-bottom: 10px !important;
    }

    .picture-input > div {
      // text-align: left;
    }

    .picture-inner {
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border: none !important;

      &:before {
        content: '';
        display: block;
        width: 200px;
        height: 170px;
        background: url('../../static/images/dropzone.png') no-repeat center center;
        margin-bottom: 20px;
        background-size: contain;
      }

      .picture-inner-text {
        display: block !important;
        color: #637381 !important;
        font-size: 15px !important;
        font-weight: 600 !important;
      }
    }

    canvas {
      background: none !important;
      border: none;
    }

    
    .btn {
      @include base-button;

      & {
        padding: 7px 10px;
        margin: 10px 4px 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BasePictureInput.vue